import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Button, AddIcon } from '@occc/ui-design-system';
import { useAppLayoutContextConsumer, Page } from '@occc-app/design-system';
import { getListPageLinks } from '@occc-app/routes/ProgramManagement/utils';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { LoyaltyEventTableContainer } from './LoyaltyEventTableContainer';

import { messages } from '../messages';
import { routeCreator } from '../utils';

export const LoyaltyEventListPage = () => {
  // useMemo is used here to avoid maximum update depth exceeded.
  const links = useMemo(() => getListPageLinks(OfferType.LoyaltyEvent), []);
  useAppLayoutContextConsumer(links);

  const isUserPermittedToCreateLoyaltyEvent = useIsUserPermittedTo(Feature.LOYALTY_EVENT_CREATE);

  return (
    <Page
      browserTabTitle={messages.listPageTitle}
      pageHeaderProps={{
        title: messages.listPageTitle,
      }}
      actions={
        isUserPermittedToCreateLoyaltyEvent ? (
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            to={routeCreator.create()}
            startIcon={<AddIcon />}
            role='button'
          >
            Create Loyalty Event Offer
          </Button>
        ) : null
      }
    >
      <LoyaltyEventTableContainer />
    </Page>
  );
};
